"use strict";

class TOITFSelect {
    constructor(selectBox = "TOITFSelectBox", initALL = true) {
        this.selectBox = selectBox;
        console.log(`Init TO ITF select interactive box module`);
        if (initALL) this.initDialog();
    }

    initDialog() {
        // init interactive box

        $('#' + this.selectBox)
            .on('shown.bs.modal', (event) => this.loadControlsValues(event))
            .on('hidden.bs.modal', () => this.finalizeBox())
            .on('keypress', (event) => {
                if (event.keyCode === 10 || event.keyCode === 13) {
                    this.onConfirm(event);
                    event.preventDefault();
                }
            })
            .find("button.confirm")
                .on('click', (event) => this.onConfirm(event));

        $("#TOITF_box_scheme-mount_tab .box-schema-control input").on("click", (event) => {
            // this.scheme_mount = $("#" + this.selectBox + " .box-schema-control.active").find(":input").val();
            this.geometry = $("#" + this.selectBox + " .automation-control.active").find(":input").val();
            this.scheme_mount = $(event.currentTarget).val();

            $("#TOITF_box_to_type_tab .img-box > img").prop("src", "/assets/img/to_itf_" + this.geometry.toLowerCase() + "_" + this.scheme_mount.toLowerCase() + ".svg")
        });

        $("#TOITF_box_to_type_tab .automation-control input").on("click", (event) => {
            // console.log($(event.target).find(":input").val())
            this.scheme_mount = $("#" + this.selectBox + " .box-schema-control.active").find(":input").val();
            // this.geometry = $("#" + this.selectBox + " .automation-control.active").find(":input").val();
            this.geometry = $(event.currentTarget).val();

            let $img = $("#TOITF_box_to_type_tab .img-box > img");
            $img.prop("src", "/assets/img/to_itf_" + this.geometry.toLowerCase() + "_" + this.scheme_mount.toLowerCase() + ".svg")
        });

        return this;
    }

    loadControlsValues(event) {
        this.scheme_mount = $("#to_itf-scheme-mount").text();
        this.geometry = $("#to_itf-scheme").text();
        $("#TOITF_box_to_type_tab .img-box > img").prop("src", "/assets/img/to_itf_" + this.geometry.toLowerCase() + "_" + this.scheme_mount.toLowerCase() + ".svg")

        if($(event.relatedTarget).prev().find(".label1").prop("id") === "to_itf-scheme")
            $("#TOITF_box_to_type").tab("show");
        else
            $("#TOITF_box_scheme-mount").tab("show");
        $("#" + this.selectBox + " input[name=to_itf_box_scheme-mount]").filter("[value=" + this.scheme_mount+ "]").parent().button("toggle");
        $("#" + this.selectBox + " input[name=to_itf_box_scheme]").filter("[value=" + this.geometry + "]").parent().button("toggle");
    }

    onConfirm() {
        $("#to_itf-scheme-mount").text(this.scheme_mount);
        $("#to_itf-scheme").text(this.geometry);
        $("#" + this.selectBox).modal("hide");
    }

    finalizeBox() {}
}

export default TOITFSelect;
